import React from 'react';
import {Box, Typography} from '@mui/material';

interface FlagProps {
  text: string;
}

const Flag: React.FC<FlagProps> = ({text}) => {
  return (
    <Box position="relative" textAlign={'center'}>
      <Box
        sx={{
          width: 190,
          height: '34px',
          padding: 1,
          paddingTop: 2,
          paddingBottom: 2,
          borderRadius: 1,
          backgroundColor: '#07274a',
          color: '#fff',
          fontSize: '12px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: 16,
            textAlign: 'center',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default Flag;
